import React from 'react';
import {Switch} from '@mantine/core';
import useSwitchState, {ApiSwitchProps} from './state';
import Loading from '../loading';
import {Container} from './styles';

const QuerySwitch: React.FC<ApiSwitchProps> = (props) => {
  const {isLoading, handleRequest} = useSwitchState(props);

  return isLoading ? (
    <Container>
      <Loading />
    </Container>
  ) : (
    <Switch
      onChange={(e) =>
        handleRequest(e.currentTarget.checked, props.field ?? 'active')
      }
      checked={props.isChecked}></Switch>
  );
};

export default QuerySwitch;
